/* src/app/shared/controls/tab-control/tab-page.component.scss */
.tab-page {
  width: 100%;
}
/*# sourceMappingURL=tab-page.component-KJ2Q34NC.css.map */
